/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://ufe4zgk45zav3edpzpdvg3skum.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-blwixqkvv5eovhgbac7k3ggyjm",
    "aws_cognito_identity_pool_id": "us-east-2:e52cf8bb-2741-4206-9226-5ad29a3815f1",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_v6tmV9QWk",
    "aws_user_pools_web_client_id": "7oll8dst08q7esghokc9ihr7e2",
    "oauth": {
        "domain": "gusdapps74ea1ff2-74ea1ff2-kiersten.auth.us-east-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://main.dz66lonf4fc3g.amplifyapp.com/,https://uat.d1f37awol0uxld.amplifyapp.com/,https://gusd-k12forms.hexalytics.ai/",
        "redirectSignOut": "http://localhost:3000/,https://main.dz66lonf4fc3g.amplifyapp.com/,https://gusd-k12forms.hexalytics.ai/,https://uat.d1f37awol0uxld.amplifyapp.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "dynamobgusdapps-kiersten",
            "region": "us-east-2"
        }
    ],
    "aws_user_files_s3_bucket": "gusd-dev-env-bucket124839-kiersten",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
